import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import { COLORS, SIZES, WEIGHT } from "theme";
//import Community from "assets/all_screens.png";

const JoinTheCommunity = ({ small, multiscreens }) => {
  return (
    <Box
      marginTop="80px"
      display="flex"
      justifyContent="center"
      textAlign="center"
    >
      <Box>
        <H2
          fontSize={small ? SIZES.twenty : SIZES.forty}
          fontWeight={WEIGHT.bold}
          textColor={COLORS.black}
          margin={SIZES.zero}
        >
          {multiscreens?.attributes?.title}
        </H2>
        <Box w={small ? "100%" : "490px"} margin="0 auto">
          <Text
            fontSize={small ? SIZES.fourteen : SIZES.twenty}
            fontWeight={WEIGHT.regular}
            textColor={COLORS.lightBlack}
            marginTop={SIZES.twentyFour}
            lineHeight="1.5"
          >
            {multiscreens?.attributes?.description}
          </Text>
        </Box>
        <Box
          w={small ? "auto" : "1287px"}
          h={small ? "auto" : "520px"}
          margin={`${small ? SIZES.twenty : SIZES.eighty} 0`}
          padding={small && SIZES.forty}
        >
          <img
            src={multiscreens?.attributes?.media?.data?.attributes?.url}
            alt={
              multiscreens?.attributes?.media?.data?.attributes?.alternativeText
            }
            height={"100%"}
            width="100%"
            style={{ objectFit: "contain" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default JoinTheCommunity;
